/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect,useState } from 'react';
import { withRouter, Link } from "react-router-dom";

function Header(props) { 
    const [data, setData] = useState("");
    const [title, setTitle] = useState("home");

    useEffect(() => {
        setTitle(props.title)
    },[props.title]);
    

    return (
        <div className="nav">
            <div className="main-nav w-left">
                <div className="inner_main">
                    <div className="nav-left f-left">
                        <div className="logo f-left">
                            <a onClick={()=>{ props.history.push("/");}}>
                                <img src={require("../../images/logo.png")}/>
                            </a>
                        </div>
                    </div>
                    <div className="nav-right f-left">
                        <div className="close-nav d-lg-none" onclick="closeNav();">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink"
                                viewBox="0 0 47.971 47.971">
                                <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                                c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                                C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                                s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z" />
                            </svg>
                        </div>
                        <ul className="menu--shylock">
                            <li  className={(props.title == "home")? "menu__item menu__item--current":`menu__item `}><a className="menu__link" onClick={() =>{props.history.push('/')}}>Home</a></li>
                            <li  className={(props.title == "treatment")? "menu__item menu__item--current":`menu__item `}><a className="menu__link"  onClick={() =>{ props.history.push('/treatment')}}>Treatment</a></li>
                            <li className={(props.title == "team")? "menu__item menu__item--current":`menu__item `}><a className="menu__link"  onClick={() =>{ props.history.push('/team')}}>Team</a></li>
                            <li className={(props.title == "about")? "menu__item menu__item--current":`menu__item `}><a className=" menu__link" onClick={() =>{ props.history.push('/about')}} >About Us</a></li>
                            <li className={(props.title == "faq")? "menu__item menu__item--current":`menu__item `}><a className="menu__link" onClick={() =>{ props.history.push('/faq')}}>FAQs</a></li>
                            <li className=""><a className="appoint_link"  onClick={() => props.history.push('/contact')}>Contact us</a></li>
                        </ul>
                    </div>
                    <div className="menu-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withRouter(Header);